import { STATUS, STATUS_PRIORITY } from "./constants/statuses"

const STATUS_MAPS = {
  backgroundCheck: {
    APPROVED: STATUS.COMPLETE,
    DENIED: STATUS.DENIED,
    EXPIRED: STATUS.EXPIRED,
    IN_PROGRESS: STATUS.PENDING,
    IN_REVIEW: STATUS.PENDING,
    UNDER_REVIEW: STATUS.PENDING,
    NEED_DOCUMENTATION: STATUS.PENDING,
    DOCUMENTATION_NEEDED: STATUS.PENDING,
  },
  playingAbilityTest: {
    PASSED: STATUS.COMPLETE,
    FAILED: STATUS.FAILED,
    EXPIRED: STATUS.EXPIRED,
    PENDING: STATUS.REGISTERED,
    QUALIFIED: STATUS.QUALIFIED,
    REGISTERED: STATUS.REGISTERED,
  },
  application: {
    APPROVED: STATUS.COMPLETE,
    ELECTED: STATUS.COMPLETE,
    STARTED: STATUS.SUBMITTED,
    SUBMITTED: STATUS.SUBMITTED,
    REJECTED: STATUS.LOCKED,
    DENIED: STATUS.LOCKED,
  },
}

export const mapBackgroundCheckStatus = status => {
  if (!status) return STATUS.OPEN
  return STATUS_MAPS.backgroundCheck[status] || STATUS.OPEN
}

export const mapPATStatus = (patData, patStatus) => {
  if (!patData && !patStatus) return STATUS.OPEN

  // Check patStatus first (more direct)
  if (patStatus?.status) {
    return STATUS_MAPS.playingAbilityTest[patStatus.status] || STATUS.OPEN
  }

  // Fall back to patData array
  if (patData && patData.length > 0) {
    const latest = patData[0]
    if (latest.status) {
      return STATUS_MAPS.playingAbilityTest[latest.status] || STATUS.OPEN
    }
  }

  return STATUS.OPEN
}

export const mapApplicationStatus = applicationStatus => {
  if (!applicationStatus) return STATUS.LOCKED

  const status = applicationStatus.status?.toUpperCase()
  return STATUS_MAPS.application[status] || STATUS.LOCKED
}

// Aggregates multiple requirement statuses into a single status
// Used when a requirement has multiple parts (e.g., multiple tests)
export const aggregateStatuses = statuses => {
  if (!statuses || statuses.length === 0) return STATUS.OPEN

  if (statuses.every(s => s === STATUS.COMPLETE)) return STATUS.COMPLETE

  // Find and return the highest priority status, excluding complete
  return STATUS_PRIORITY.reduce((highest, priorityStatus) => {
    if (priorityStatus === STATUS.COMPLETE) return highest
    return statuses.includes(priorityStatus) ? priorityStatus : highest
  }, STATUS.OPEN)
}
